var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m9.52 39h3.459v10.722a3.281 3.281 0 0 0 3.278 3.278h9.722v8a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1v-13.649l7.077-8.846a22.469 22.469 0 0 0 -17.546-36.505h-3.883a17.7 17.7 0 0 0 -17.306 14.187 17.719 17.719 0 0 0 -.342 3.46v5.1l-5.679 10.541a2.516 2.516 0 0 0 2.22 3.712zm-.456-2.763 5.8-10.763a.99.99 0 0 0 .12-.474v-5.352a15.644 15.644 0 0 1 15.643-15.648h3.883a20.469 20.469 0 0 1 15.983 33.256l-7.3 9.119a1.006 1.006 0 0 0 -.218.625v13h-15v-8a1 1 0 0 0 -1-1h-10.718a1.279 1.279 0 0 1 -1.278-1.278v-11.722a1 1 0 0 0 -1-1h-4.459a.517.517 0 0 1 -.456-.763z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m18.979 27h2v3a1 1 0 0 0 1 1h6v2h2v-2h3v8h2v-8h2v2a1 1 0 0 0 1 1h1v4h2v-4h3a1 1 0 0 0 1-1v-3h2v4.586l-2.708 2.707 1.415 1.414 3-3a1 1 0 0 0 .293-.707v-8h2a1 1 0 0 0 1-1v-8a1 1 0 0 0 -1-1h-2v-4a1 1 0 0 0 -1-1h-2v-2a1 1 0 0 0 -1-1h-6v-2a1 1 0 0 0 -1-1h-8a1 1 0 0 0 -1 1v2h-4a1 1 0 0 0 -1 1v2h-2a1 1 0 0 0 -1 1v4h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1zm1-8h2a1 1 0 0 0 1-1v-4h2a1 1 0 0 0 1-1v-2h2.021v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3h-2v2h-3v-2a1 1 0 0 0 .979-1v-2h6v2a1 1 0 0 0 1 1h6v1h-5a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h3v-2h-2v-3h7v3h-3v2h6v6h-2a1 1 0 0 0 -1 1v2h-5v-4h3v-2h-4a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2v2h-4v-6a1 1 0 0 0 -1-1h-3v2h2v2h-5v-3h-2v3h-7v-2h4a1 1 0 0 0 1-1v-4h-2v3h-6z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m29.979 24h2v-2h3.021a1 1 0 0 0 1-1.007l-.021-3-2 .014.014 1.993h-2.014v-2a1 1 0 0 0 -1-1h-6v2h5z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m27.979 35h2v2h-2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m32.979 41h2v2h-2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m38.979 40h2v2h-2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.4c3e4013c8d99922918f993a3192cfb4.svg";
export { ForwardRef as ReactComponent };